<div class="background"></div>
<div class="">
  <!-- <app-inventory></app-inventory> -->
  <app-egg-shrine [eggs]="eggs"></app-egg-shrine>
  <div class="mt">
    <app-egg-map [eggs]="eggs"></app-egg-map>
  </div>
</div>
